module.exports = __webpack_public_path__ + "static/pragribe-logo-b5d286c92ffeed8322078436f5ed7279.svg";